import controller from './vendor.controller';
import template from './vendor.pug';

const VendorComponent = {
  template,
  controller,
};

export default VendorComponent;



// WEBPACK FOOTER //
// ./client/app/cases/vendor/vendor.component.js